import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export interface SelectOption {
  value: string;
  label: string;
}

interface OptionSelectProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  // Adds a first option that clears the value. Its text is what "nothing picked" reads as.
  emptyLabel?: string;
  // When set, the value is also written to a hidden input so a plain form can send it.
  name?: string;
  required?: boolean;
  invalid?: boolean;
  describedBy?: string;
  disabled?: boolean;
}

// The select will not take an empty string as an option, so "nothing" travels as this.
const NONE = '__none__';

// A labelled select over a short list of options. An empty string means nothing is picked.
const OptionSelect = ({
  id,
  value,
  onChange,
  options,
  placeholder = 'Choose',
  emptyLabel,
  name,
  required = false,
  invalid = false,
  describedBy,
  disabled = false,
}: OptionSelectProps) => {
  return (
    <>
      {name ? <input type="hidden" name={name} value={value} /> : null}
      <Select
        value={value}
        onValueChange={(next) => onChange(next === NONE ? '' : next)}
        disabled={disabled}
      >
        <SelectTrigger
          id={id}
          className="w-full"
          aria-required={required || undefined}
          aria-invalid={invalid || undefined}
          aria-describedby={describedBy}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {emptyLabel ? <SelectItem value={NONE}>{emptyLabel}</SelectItem> : null}
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </>
  );
};

export default OptionSelect;
